import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import "./virgin-marketing.scss"
import Button from "../shared/button/text-button"
import wrench from "images/splashScreens/virgin-wrench.png"
import lock from "images/splashScreens/virgin-lock.png"
import router from "images/splashScreens/virgin-router.png"
import reliability from "images/splashScreens/virgin-reliability.png"
import netflix from "images/splashScreens/virgin-netflix.jpg"

const MarketingVirgin2 = ({ handleButtonClick, handleBackButtonClick }) => (
  <div className="marketing-page marketing-page--virgin-2">
    <h1>
      Our intelligent broadband lets you crack on with the things you love​
    </h1>
    <div className="marketing-page--info">
      <div className="marketing-page--info--image">
        <img src={router} alt="" />
      </div>
      <div className="marketing-page--info--text">
        <p>
          Our broadband is fast. In fact, our fastest widely available average
          speeds are 5x faster than Sky and BT’s. Using DOCSIS® 3 insulated
          cable technology, we will reliably get you the speeds you need.​ ​
        </p>
        <p>
          Plus our new Intelligent WiFi is designed to automatically sort issues
          for you and optimises your broadband use so you get the most out of
          our SmartHub 3 router, Virgin Media app and our intelligent WiFi
          boosters.
        </p>
      </div>
    </div>
    <div className="marketing-page--extras">
      <p className="bold">
        Enjoy not only the UK’s fastest and most reliable, but also the most
        intelligent broadband​
      </p>
      <div className="thumbnailContainer">
        <div>
          <img src={wrench} alt="" />
          <p className="bold">Meet intelligent Wifi​</p>

          <p>
            It adapts to the number of people and devices online around your
            home, so you can just crack on with the things you love.​
          </p>
        </div>
        <div>
          <img src={lock} alt="" />
          <p className="bold">Ultra-secure</p>
          <p>
            Our broadband comes with Web Safe included, giving you the option to
            block access to unsuitable or potentially fraudulent sites.​
          </p>
        </div>
        <div>
          <img src={reliability} alt="" />
          <p className="bold">Banish those WiFi blackspots </p>
          <p>
            Got a WiFi blackspot in your home? A WiFi Booster can help boost
            WiFi signal in the room where you’ve plugged it in. Magic.​
          </p>
        </div>
        <div>
          <img src={netflix} alt="" />
          <p className="bold">Join the Stream Team </p>
          <p>
            Enjoy over 70 channels with our lightning fast broadband with
            average speeds of 54mbps and the player bundle from £33 a month.​
          </p>
        </div>
      </div>
    </div>

    <div className="marketing-button-container">
      <Button text="Back" onClick={handleBackButtonClick} />
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingVirgin2.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  handleBackButtonClick: PropTypes.func.isRequired
}

export default MarketingVirgin2
